import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { config } from '../../../util/config';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-wa0054',
  templateUrl: './wa0054.component.html',
  styleUrls: ['./wa0054.component.scss']
})
export class Wa0054Component implements AfterViewInit {
  public componentTitle = 'WA0054:データマッピング定義削除';

  public isShowSendLoading = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  public production = environment.production;
  public backgroundColor: string;
  public updprogramCd = 'wa0054';

  public uploadpatterns;

  public uploadobjects;
  public uploadobjects_objectname;

  public selectUploadObjectId: FormControl;
  private errorInfo = '';

  private uploadObjectId = null;

  private filetypes;

  private uploadObjectIdCls = '';
  private selectUploadObjectIdCls = '';

  private isSubmitButtonEnabled = false;

  constructor(private interfaceMappingService: InterfaceMappingService, private commonService: CommonService, private router: Router, private dialogsService: DialogsService) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.selectUploadObjectId = new FormControl('', [Validators.required]);
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.isShowSendLoading = true;
    this.interfaceMappingService
      .uploadobjects()
      .then(outputJson => {
        this.isShowSendLoading = false;
        console.log(outputJson);
        this.filetypes = outputJson.uploadobjects;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onUploadObjectChange() {
    this.errorInfo = '';
    if (this.uploadObjectId === '') return;

    let matchData = this.filetypes.filter(function (item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.uploadObjectId == this) {
        return true;
      }
    }, this.uploadObjectId);

    if (matchData.length === 0) {
      this.errorInfo = 'マッピング種別を選択してください。';
      return;
    }

    this.interfaceMappingService
      .uploadpattern(matchData[0].uploadObjectId)
      .then(outputJson => {
        this.isShowSendLoading = false;
        console.log(outputJson);
        this.uploadpatterns = outputJson.uploadpatterns;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onSubmit() {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    // if (this.isShowSendLoading === true) {
    //   return;
    // }

    if (!this.isSubmitButtonEnabled) return;

    // this.isShowSendLoading = true;

    // 定義ファイル読み込み

    // tslint:disable-next-line:prefer-const
    let matchData = this.uploadpatterns.filter(function (item, index) {
      if (item.uploadObjectsPatternId === this) {
        return true;
      }
    }, Number.parseInt(this.selectUploadObjectId.value));

    if (matchData.length === 0) {
      this.isShowSendLoading = false;

      this.errorInfo = '削除するデータマッピング定義を選択してください。';
      return;
    }

    console.log(matchData[0]);

    this.interfaceMappingService
      .delete_uploadpattern(matchData[0].uploadObjectsPatternId)
      .then(outputJson => {
        // console.log("outputJson: " + JSON.stringify(outputJson));
        this.isShowSendLoading = false;

        this.uploadObjectId = null;
        sessionStorage.setItem('SuccessInfoMessage', 'データマッピング定義を削除しました。');
        // this.onUploadObjectChange();
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngDoCheck() {
    this.uploadObjectIdCls = this.uploadObjectId == null || this.uploadObjectId + '' === '' ? '' : 'active';
    this.selectUploadObjectIdCls = this.selectUploadObjectId.value + '' === '' ? '' : 'active';

    if (this.uploadObjectId == null || this.uploadObjectId + '' === '') {
      this.selectUploadObjectIdCls = 'disabled';
      this.selectUploadObjectId.setValue('');
      this.selectUploadObjectId.disable();
    } else this.selectUploadObjectId.enable();

    this.isSubmitButtonEnabled = this.uploadObjectIdCls === 'active' && this.selectUploadObjectIdCls === 'active';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0054/wa0054.component.ts